@if (isTeamViewWithoutBoard) {
    <adapt-call-to-action [learnMoreUrl]="learnMoreUrl">
        <adapt-call-to-action-title>No boards configured</adapt-call-to-action-title>
        <p>Actions are a visual system for managing work as it moves through a process. It visualises both the process (the workflow) and
            the actual work passing through that process. The goal is to identify potential bottlenecks in your process and fix them so work
            can flow through it cost-effectively at an optimal speed or throughput.</p>
        <div *adaptIfAuthorised="ConfigureTeamVerifier; entity: team">
            <p>You can add a board from 'Configure Team / Actions'</p>
        </div>
        <button *adaptIfAuthorised="ConfigureTeamVerifier; entity: team"
                adaptCallToActionButton
                adaptButton="configure"
                (click)="configureTeam()">Team</button>
    </adapt-call-to-action>
} @else {
    <adapt-two-column-layout [fullPage]="true"
                             [removeColumnPadding]="true"
                             leftColumnWidthClasses="col-12 col-md-6 col-lg-7 col-xl-8 d-flex flex-column {{ hideOverflow ? 'overflow-y-hidden' : '' }}"
                             rightColumnWidthClasses="col-12 col-md-6 col-lg-5 col-xl-4 box-shadow white-background">
        <ng-container left-column>
            @if (inMultipleSelectionMode) {
                <adapt-item-batch-action-toolbar [items]="checkedItems"
                                                 [isPersonalBoardView]="!!person"
                                                 (actionPerformed)="checkedItems = []"
                                                 (exitSelectionMode)="toggleMultipleSelection()"></adapt-item-batch-action-toolbar>
            }
            <!-- The board will only show assignees if is team board -->
            <adapt-board [items]="items"
                         [showAssignees]="!!team"
                         [selectedItem]="selectedItem"
                         [inMultipleSelectionMode]="inMultipleSelectionMode"
                         [(checkedItems)]="checkedItems"
                         [columnGroup]="columnGroup"
                         (showBacklogClick)="showBacklogColumn($event)"
                         (selectedItemChange)="onSelectedItemChanged($event)"
                         (itemDialogOpened)="itemDialogOpened.emit($event)"
                         (itemDialogClosed)="itemDialogClosed.emit($event)"
                         [showStatuses]="visibleItemStatuses"></adapt-board>
        </ng-container>
        @if (selectedItem && isMD) {
            <adapt-item-preview right-column
                                [item]="selectedItem"
                                (itemDialogOpened)="itemDialogOpened.emit($event)"
                                (itemDialogClosed)="itemDialogClosed.emit($event)"
                                (closeClicked)="previewClosed = true; onSelectedItemChanged(undefined)"
                                class="d-flex flex-grow-1 h-100"
                                data-test="item-preview"></adapt-item-preview>
        }
    </adapt-two-column-layout>
    <div adaptToolbarContent
         alignment="left"
         class="d-flex align-items-center">
        @if (isXL || showLeftToolbarInSmallerScreen) {
            <adapt-select-board class="kanban-board-toolbar-selection"
                                [team]="team"
                                [boards]="filterByBoards.length ? filterByBoards : undefined"
                                (boardsChange)="onBoardSelectionChanged($event)"
                                [allowMultiSelection]="true"
                                [showTeamBoards]="!!team"
                                data-test="board-dropdown"></adapt-select-board>
            @if (hasEditableBoard$ | async) {
                <div class="kanban-board-toolbar-buttons">
                    <button class="btn-item-add"
                            adaptButton="add"
                            [adaptBlockingClick]="addItem">action</button>
                </div>
            }
            @if (!isXL) {
                <div class="ms-3 align-self-center btn-link"
                     (click)="showLeftToolbarInSmallerScreen = false">
                    <i class="fal fa-chevron-right"></i>
                </div>
            }
        }
        @if (isXL || !showLeftToolbarInSmallerScreen) {
            @if (!isXL) {
                <div class="ms-3 align-self-center btn-link"
                     (click)="showLeftToolbarInSmallerScreen = true">
                    <i class="fal fa-chevron-left"></i>
                </div>
            }
            <dx-text-box class="ms-3"
                         placeholder="Filter by keyword"
                         mode="search"
                         [width]="150"
                         (valueChange)="onSearchTextValueChanged($event)"
                         data-test="keyword-filter"></dx-text-box>
        }
    </div>
    <adapt-menu adaptToolbarContent
                [ordinal]="2001"
                [items]="toolbarMenu"
                data-test="kanban-board-menu"></adapt-menu>
    <div class="d-flex align-items-center"
         adaptToolbarContent
         [ordinal]="90">
        <button class="btn btn-default"
                [adaptButtonToggle]="backlogShown"
                (adaptButtonToggleChange)="toggleBacklog()">
            <i class="fal fa-fw me-1"
               [ngClass]="BacklogIconClass"></i>
            Backlog
            @if (showBacklogBadge) {
                <span class="badge bg-primary ms-1">{{ backlogCount }}</span>
            }
        </button>
    </div>
    <!-- kanban filter will insert a filter button on the toolbar with ordinal 100 -->
    <adapt-kanban-filter [team]="team"
                         [filter]="filter"
                         (filterChange)="onFilterChanged($event)"></adapt-kanban-filter>
}
